import { Injectable } from '@angular/core';
import { UserStatus } from '../enums/user-status';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class UserStatusCssProviderService {
  private readonly entries = new Map<UserStatus, string>([
    [UserStatus.New, 'bg-indigo-50 text-indigo-700 ring-indigo-700/10'],
    [UserStatus.Active, 'bg-green-50 text-green-700 ring-green-600/20'],
  ]);

  public css(status: UserStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The css classes for "${status}" not found.`,
      );
    }

    return of(result);
  }
}
